<script setup lang="ts">
import {
  ErrorFactory,
  LanguageFactory,
  ConstantFactory,
  ConfigService,
  BroadcastService,
WorkflowFactory
} from "@/common/services/services.module";
import { $inj, $injByInterface } from "@/common/decorators/depinject";
import { WorkflowStatesConstant } from "@/common/constant/WorkflowStatesConstant";
import { ErrorHandler } from "@/open/handlers/ErrorHandler";
import { OpenLanguageKeysConstant } from "@/common/constant/OpenLanguageKeysConstant";
import { BroadcastConstant } from "@/common/constant/BroadcastConstant";
import type IRouterService from "@/common/services/utils/IRouterService";
import { onErrorCaptured } from "vue";
import { useRoute } from "vue-router";

try {
  const routerService = $injByInterface<IRouterService>("IRouterService");
  const languageFactory = $inj(LanguageFactory);
  const constantFactory = $inj(ConstantFactory);
  const errorFactory = $inj(ErrorFactory);
  const workflowFactory = $inj(WorkflowFactory)
  workflowFactory.setBeginPreloadingStatus();

  await $inj(ConfigService).bootstrap();

  constantFactory.init();

  await languageFactory.getAll().then(async () => {
    errorFactory.setEodError(
      await languageFactory.getSynchronous(OpenLanguageKeysConstant.MESSAGE_CODE_OPEN_EOD_ERROR_SCREEN)
    );
  });
  const broadcastService = $inj(BroadcastService);
  broadcastService.broadcast(BroadcastConstant.BLT_REPLACE_TOOLBAR_TITLE, null);

  // routing to start person
  routerService.push({
    name:
      routerService.currentRoute.value.name === WorkflowStatesConstant.ROOT.STATE
        ? WorkflowStatesConstant.START_PERSON.STATE
        : routerService.currentRoute.value.name || "",
    params: routerService.currentRoute.value.params,
    query: routerService.currentRoute.value.query
  })
} catch (e) {
  ErrorHandler.handle(e);
}
onErrorCaptured(function () {
  //note: an error "OPEN_NOT_AUTHORIZED" is expected when Tracker() called.
  //This happens when you reload the URL in browser "/workflow/workspaceUUID?trackerUUID"
  //In this case we redirect either to continue or error page
  const route = useRoute();
  const workspaceUUID = route.params.workspaceUUID as string;
  const trackerUUID = route.query.trackerUUID as string;
  ErrorHandler.handleNavigationErrorForWorkspace(workspaceUUID, trackerUUID);
  const bubbleUpErrorToGlobalHandler = false;
  return bubbleUpErrorToGlobalHandler;
});
</script>

<template>
  <router-view></router-view>
</template>
